var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute left-0 top-0 w-0 h-0 invisible"},[_c('Wallet'),_c('CreateUser'),_c('ChangePassword'),_c('UpdateBalance'),_c('EditWallet')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }